import { apiClient } from './axiosConfig';

// Preuve d'une janaza (flyer d'origine : PNG, JPG ou PDF), conservée 7 jours par le serveur.
// Réponse de l'envoi : { preuveUrl, preuveType }
export const uploadPreuve = (priereId, file, utilisateurId) => {
  const fd = new FormData();
  fd.append('file', file);
  return apiClient.post(`/api/PriereJanaza/${priereId}/preuve`, fd, {
    params: utilisateurId != null ? { utilisateurId } : undefined,
  });
};

export const deletePreuve = (priereId, utilisateurId) =>
  apiClient.delete(`/api/PriereJanaza/${priereId}/preuve`, {
    params: utilisateurId != null ? { utilisateurId } : undefined,
  });
